import { gql } from "@apollo/client/core";

export default gql`
  query AdminRawReport(
    $entityIds: [String!]
    $dateFrom: String
    $dateTo: String
    $reportingFrameworks: [ReportingFrameworkEnum!]
  ) {
    getDataPointsEncodedReport(
      entityIds: $entityIds,
      dateFrom: $dateFrom,
      dateTo: $dateTo,
      reportingFrameworks: $reportingFrameworks
    )
  }
`;
